import { useId } from "react"
import { Checkbox as UiCheckbox } from "@/shared/ui/checkbox"

export function Checkbox({
	label,
	checked,
	onChange,
}: {
	label: string
	checked: boolean
	onChange: (checked: boolean) => void
}) {
	const id = useId()
	return (
		<label className="flex items-center gap-2 text-sm" htmlFor={id}>
			<UiCheckbox id={id} checked={checked} onCheckedChange={(next) => onChange(next === true)} />
			{label}
		</label>
	)
}
